module.exports = __webpack_public_path__ + "static/media/TUNE_6535.5b43d68d.jpg";